<template>
	<card class="ReLeadSearchCard">
		<div class="card-user">
			<div class="left_part">	
				<div class="">
					<div class="avatarBlk ">
						<h4 class="title"><!--<a :href="`/data/callcenter/id/${ApiData.id}`"><b> Лид ID {{ApiData.id}} </b></a>-->
							<router-link tag="a" :to="`/data/callcenter/id/${ApiData.id}`">
								<b> Лид ID {{ApiData.id}} </b>
							</router-link>	
						</h4>
						<div class="mb-2 ">
							<span class="badge badge-pill badge-primary mr-2" v-if="ApiData.operation_type !=''">{{ ApiData.operation_type }}</span>
							<span class="badge badge-pill badge-info mr-2" v-if="ApiData.isNewBuilding == 1 && 
							(ApiData.lead_status !='Не отработан' && ApiData.lead_status !='Некачественный лид') && ApiData.isNewBuilding != 3">Новостройки</span>
							<span class="badge badge-pill badge-info mr-2" v-if="ApiData.isNewBuilding == 0 && 
							(ApiData.lead_status !='Не отработан' && ApiData.lead_status !='Некачественный лид') && ApiData.isNewBuilding != 3">Вторичка</span>
							<span class="badge badge-pill badge-info mr-2" v-if="ApiData.operation_type == 'Сдать' || ApiData.operation_type == 'Снять' || ApiData.isNewBuilding == 3">Аренда</span>
							<!-- <span :class="[(ApiData.lead_status == 'Не отработан')?'badge-danger':'badge-success']"></span> -->
							<span v-if="ApiData.lead_status!=''" class="badge " :class="[{'badge-danger': ApiData.lead_status == 'Не отработан'}, {'badge-success': ApiData.lead_status == 'Назначен ответственный'}, 
																						{'badgeDeficient': ApiData.lead_status == 'Некачественный лид'}, {'badge-warning': ApiData.lead_status == 'Повторный звонок'}]" >{{ApiData.lead_status}}</span>
						</div>
						<div><base-button @click="EditCard(ApiData.id)"  type="primary" simple>Редактировать</base-button></div>
						
					</div>	
				</div>
				<div class="fioContactsBlk">
					<div class="fioContactsBlk">	
						<div class="fioBlk mb-3">
							<h4 class="title">Общая информация</h4>
							<p class="description"><span class="font-weight-bold mr-1">Тип объекта: </span> {{ApiData.lead_obj_type}}</p>
							<p class="description"><span class="font-weight-bold mr-1">Источник: </span> {{ApiData.import_id}} 
								<span v-if="ApiData.dialed_number && ApiData.dialed_number!=''"> (c номера {{ this.$GVO.formatPhoneNumber(ApiData.dialed_number)}})
								</span>
							</p>
							<!--p class="description"><span class="font-weight-bold mr-1">Источник: </span> {{ApiData.import_id}} (c {{ $GVO.formatPhoneNumber(ApiData.phone) }})</!--p-->
							<p class="description"><span class="font-weight-bold mr-1">Рекламный источник: </span> {{ApiData.adsSourceName}}</p>
							<p class="description"><span class="font-weight-bold mr-1">Создал лид: </span> <router-link :to="`/data/staff/id/${ApiData.author_id}`"> {{ApiData.author_name}}</router-link> </p>
							<!-- <p class="description"><span class="font-weight-bold mr-1" v-if="ApiData.isObjects == 1">Обращение по объекту: </span> {{ApiData.objects_json}}</p> -->
							<!-- <p class="description"><span class="font-weight-bold mr-1">Примечание: </span> {{ApiData.description}}</p> -->
							<div class="collapseRegular" v-if="ApiData.description!=''">
								<div class="objectDescr" :class="[isActive ? 'text-truncate' : '']">
									<p ><b>Примечание:</b>  {{ApiData.description}} </p>
								</div>
								<button class="expandBtn" @click="toggleText()">{{expandText.text}}</button>
							</div>
							
						</div>
					</div>	
				</div>
			

			</div>
			<div class="right_part">
			
				<div class="">
					<div class="fioContactsBlk">
						<div class="fioBlk mb-3">
							<h4 class="title">Клиент</h4>
							<p class="description" v-if="ApiData.client_id!=''"><span class="font-weight-bold mr-1">ФИО: </span>
								<router-link :to="'/data/clients/id/'+ApiData.client_id + '?phoneint=' + ApiData.phone" >
									<span v-if="ApiData.client_surname!=''" class="mr-2">{{ ApiData.client_surname }}</span>
									<span v-if="ApiData.client_name!=''" class="mr-2">{{ ApiData.client_name }}</span>
									<span v-if="ApiData.client_patronymic!=''" class="mr-2">{{ ApiData.client_patronymic }}</span>
								</router-link>

							</p>
							<p class="description" ><span class="font-weight-bold mr-1">ИД клиента: </span> {{ApiData.client_id}}</p>
							<p class="description" v-if="ApiData.phone!=''"><span class="font-weight-bold mr-1">Тел.: </span> {{ApiData.phone}}</p>
						</div>
					</div>
				</div>


				<div class="">
					<div class="uslugaBlk">
						<h4 class="title" v-if="ApiData.isObjects == 1">Ответственный</h4>
						
						<div class="col mb-3 ml-2 px-0" v-if="ApiData.isObjects == 1">

							<div v-if="getObjects && getObjects.length>0" class="ml-1">
								<ul class="list-unstyled result-marker" >
									<li v-for="obj in getObjects" :key="obj.id" style="border-bottom: 1px dashed #01B0E0; margin-bottom: 15px;">
										<router-link :to="'/data/module/mo/object/'+obj.id">Объект ID: {{ obj.id }}</router-link>

										<p class="description" v-if="ApiData.service_agent_id != ''">
											<router-link :to="`/data/staff/id/${obj.service_agent_id}`" class="mr-1"> {{obj.service_agent_fio}}</router-link>
											
											<el-popover
												placement="left"
												:title="obj.service_agent_fio"
												width="500"
												trigger="click"
												
												>
												<template v-slot:reference>
													<base-button class="btn btn-icon no-border btn-simple btn-primary my-0 ml-2 btn-watch-icon"><i class="tim-ic ic-eye"></i></base-button>
												</template>
												<template v-slot:default>
													<div class="" >
														<!-- <ReLeadStaffInfo :agent_id="agentIdToTransfer" :agent_name="obj.service_agent_fio" /> -->
														<ReLeadStaffInfo :objData="obj" :lead_id="ApiData.id" />
														
													</div>
												</template>
												
											</el-popover>
										</p>
										

									</li> 
								</ul> 
							</div>

							
						</div>
						<h4 class="title" v-if="ApiData.isObjects == 0">Ответственный (не объектовый лид)</h4>
						<!-- <p class="description" v-if="ApiData.agent_id != '' && ApiData.isObjects == 0">
							
							<el-popover
								placement="top-start"
								title="Title"
								width="300"
								trigger="hover"
								:key="ApiData.agent_id"
								>
								<template slot="reference">
									<span class="font-weight-bold mr-1" >Ответственный за услугу: </span> <a :href="`/data/staff/id/${ApiData.agent_id}`"> {{ApiData.agent_name}}</a>
								</template>
								<template slot="default">
									<div class="col">
										<p> {{ApiData.agent_name}}</p>
										<p> {{ ApiData.agent_id }}</p>
										<p> {{  }}</p>	
									</div>
									
								</template>
							</el-popover>
							
						</p> -->
						<p class="description" v-if="ApiData.agent_id != '' && getObjects && getObjects.length==0">
							<router-link :to="`/data/staff/id/${ApiData.agent_id}`" class="mr-1"> {{ApiData.agent_name}}</router-link>
							
							<el-popover
								placement="left"
								:title="ApiData.agent_name"
								width="500"
								trigger="click"
								>
								<template v-slot:reference>
									<base-button class="btn btn-icon no-border btn-simple btn-primary my-0 ml-2 btn-watch-icon"><i class="tim-ic ic-eye"></i></base-button>
								</template>
								<template v-slot:default>
									<div class="col" >
										<!-- <ReLeadStaffInfo :agent_id="agentIdToTransfer" :agent_name="obj.service_agent_fio" /> -->
										<ReLeadStaffInfo :objData="leadStaffInfo" :lead_id="ApiData.id" />
										
									</div>
								</template>
								
							</el-popover>
						</p>
						<!-- <p class="description" v-if="ApiData.agent_id != '' && ApiData.isObjects == 0 ">ID услуги:  {{ApiData.service_id}} </p> -->
					</div>
				</div>

				<!-- <div class="col-xl-2 col-lg-6 col-md-12"> -->
					<!-- <div class="">
							<h4 class="title">Состояние</h4>
							<p class="description" v-if="ApiData.lead_status!=''">{{ApiData.lead_status}} </p>
						</div> -->
				
			</div>
			
		
		
		
		</div>
		<!-- <pre>{{ApiData}}</pre> -->

		<div class="card-user mt-2">
			<div class="row mx-0">			
				<div class="d-flex mr-5 align-items-baseline">
					<h4 class="mb-0 mr-2">Создан</h4>
					<p class="description">{{$GVO.convertDateTimeFromMysql(ApiData.InsertTime)}}</p>
				</div>
				<div class="d-flex mr-5 align-items-baseline">
					<h4 class="mb-0 mr-2">Посл. изменение</h4>
					<p class="description">{{$GVO.convertDateTimeFromMysql(ApiData.UpdateTime)}}</p>
				</div>
				<!-- <div v-if="ApiData.STATUS != 'Сделка закрыта'" class="d-flex mr-5 align-items-baseline">
					<h4 class="mb-0 mr-2">Обработан</h4>
					<p class="description">{{$GVO.convertDateTimeFromMysql(ApiData.CompletionTime)}}</p>
				</div> -->
			</div>
		</div>

		<!-- <pre>{{ ApiData }}</pre> -->
	</card>
</template>

<script>
	import { Tooltip, Button, Popover } from 'element-ui';
	import ReLeadStaffInfo from 'src/our_components/ReLeadStaffInfo.vue';
	
	
	export default {
		name: 'ReLeadSearchCard',
		components: {
			[Button.name]: Button,
			[Tooltip.name]: Tooltip,	
			[Popover.name]: Popover,
			ReLeadStaffInfo,

		},
		props: {
			ApiData: [Object, Array],
			objId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: [String, Number],
				default: '',
			},
			
		},
		data () {
			return {
				ver: 1,
				masLeadObjects: [],
				leadStaffInfo: {
					staff_info_poz_name: this.ApiData.staff_info_poz_name,
					staff_info_structure_name: this.ApiData.staff_info_structure_name,
					staff_info_mobile_phone: this.ApiData.staff_info_mobile_phone,
					staff_info_internal_phone: this.ApiData.staff_info_internal_phone,
					staff_info_boss_name: this.ApiData.staff_info_boss_name,
					staff_info_boss_mobile_phone: this.ApiData.staff_info_boss_mobile_phone,
					staff_info_boss_internal_phone: this.ApiData.staff_info_boss_internal_phone,
				},
				expandText: {
					text: "Показать полностью"
				},
				isActive: true,
				// objPotrebnostiFields:{
				// 	'all':['rooms','district_ids','metro_ids','fin_purchase'],
				// 	'15':['rooms','district_ids','metro_ids','fin_purchase'],
				// }
			}
		},
		computed: {
			
			// masPotrebnosti: function(){
			// 	let masRet = [];
			// 	let masFields = [];
			// 	if(Object.keys(this.objPotrebnostiFields).indexOf(this.ApiData.BP_ID) != -1){
			// 		masFields = this.objPotrebnostiFields[this.ApiData.BP_ID];
			// 	}else{
			// 		masFields = this.objPotrebnostiFields['all'];
			// 	}
			// 	if(masFields.length>0){
			// 		for (let i = 0; i < masFields.length; i++) {
			// 			if(typeof this.ApiData[masFields[i]] != 'undefined' && this.ApiData[masFields[i]] != ''){
			// 				if(this.getPotrebnostiNormValue(masFields[i],this.ApiData[masFields[i]]) != '')
			// 					masRet.push(this.getPotrebnostiNormValue(masFields[i],this.ApiData[masFields[i]]));
			// 			}
			// 		}
			// 	}
			// 	return masRet;
			// },
			// daysInWork(){
			// 	let daysInWorkTotal = this.ApiData.InsertTime.replace(' ', 'T') +'Z';			
			// 	let d = new Date();
			// 	let newDateFormated = d.getFullYear() + '-' + ('0'+(d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + 'T' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':' + ('0' + d.getSeconds()).slice(-2) +'Z';
			// 	//console.log(daysInWorkTotal);
			// 	//console.log(newDateFormated);

			// 	let t = Date.parse(newDateFormated) - Date.parse(daysInWorkTotal);
			// 	let minutes = Math.floor((t / 1000 / 60) % 60);
			// 	let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
			// 	let days = Math.floor(t / (1000 * 60 * 60 * 24));
			// 	return `${days} д ${hours} ч ${minutes} м`;
				
			// 	//ниже оригинал
			// 	/*
			// 	let t = Date.parse(new Date()) -  Date.parse(this.ApiData.InsertTime);
			// 	//let seconds = Math.floor((t / 1000) % 60);
			// 	let minutes = Math.floor((t / 1000 / 60) % 60);
			// 	let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
			// 	let days = Math.floor(t / (1000 * 60 * 60 * 24));
			// 	return `${days} д ${hours} ч ${minutes} м`;
			// 	//return moment(this.ApiData.InsertTime).fromNow();
			// 	*/
			// }, 
			getObjects: function(){
				let objectsarr = [];
				if(this.ApiData.objects_json !='' && typeof this.ApiData.objects_json !='undefined'){
					// this.masLeadObjects = JSON.parse(this.ApiData.objects_json);
					objectsarr = JSON.parse(this.ApiData.objects_json);
					// return objectsarr;
				} 
				return objectsarr;
			},
			// transferStaffId: function(){

			// }
			
		},
		methods: {
			
			OpenCard(id){
				this.$router.push({path: '/data/callcenter/id/'+id});
			},
			EditCard(id){
				this.$router.push({path: '/data/callcenter/id/'+id+'/edit'});
			},
			toggleText(event) {
				this.isActive = !this.isActive;
				if (this.isActive) {
					this.expandText.text = "Показать полностью";
				} else this.expandText.text = "Скрыть";
			},
			// getPotrebnostiNormValue(valType,value){
			// 	let masResult = [];
			// 	switch (valType) {
			// 		case 'rooms':
			// 			masResult = this.getPotrebnostiCatNormValue(value.split(','),'CAT_ROOMS');
			// 			break;
			// 		case 'district_ids':
			// 			masResult = this.getPotrebnostiCatNormValue(value.split(';'),'CAT_DIST','name_tr');
			// 			break;
			// 		case 'metro_ids':
			// 			masResult = this.getPotrebnostiCatNormValue(value.split(';'),'CAT_METRO');
			// 			break;
			// 		case 'fin_purchase':
			// 			if(parseFloat(value) > 0)
			// 				masResult.push(this.$GVO.formatAmount(parseFloat(value)));
			// 			break;
			// 		default:
			// 			break;
			// 	}
			// 	return masResult.join(', ');
			// },
			// getPotrebnostiCatNormValue(masData,cat_name,cat_key){
			// 	let masResult = [];
			// 	for (let i = 0; i < masData.length; i++) {
			// 		if(masData[i] != ''){
			// 			let v = this.$GVO.GetCatValName(cat_name,masData[i],cat_key);
			// 			if(v != false){
			// 				masResult.push(v);
			// 			}else{
			// 				masResult.push(masData[i]);
			// 			}
			// 		}						
			// 	}
			// 	return masResult;
			// },
			
		},
		mounted(){
			
		},	
	}
</script>
<style scoped>
	.ReLeadSearchCard {border: 1px solid #9e77f3;  box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important;}
	.ReLeadSearchCard .card-user{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.ReLeadSearchCard .card-user .author{margin-top: 0px;}
	.card-user .left_part, .card-user .right_part{
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
	}
	/* .card-user .left_part{max-width:490px;} */
	/* .card-user .right_part{justify-content: space-between;} */
	.card-user .left_part > *, .card-user .right_part > *{display: inline-block; vertical-align: top; margin-right: 15px;}
	/*.card-user .right_part > *{width: calc(100% / 3); min-width: 180px;}*/

	.avatarBlk{width:230px; display: flex; flex-direction: column;}
	.avatarBlk .avatar{
		object-fit: contain;
		background-color: white;
	}

	.fioContactsBlk{
		display: flex;
		width: 250px;
	}
	.ReLeadSearchCard .description {word-break: break-word;}
	p.description{font-size: 1em;}
	p.description a > i{ margin-right: 5px;}

	.btn-icon .fab{
		position: absolute;
		font-size: 1em;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-12px, -12px);
		transform: translate(-12px, -12px);
		line-height: 1.5626rem;
		width: 24px;
	}
	.service-col {display: flex; flex-direction: column;}
	.service-row {display: flex; flex-wrap: wrap;}
	.agent-name, .service-title {font-weight: bold;  padding-left: 8px;}
	/* .marker::before {
		content: "\20DD";
		color: #01B0E0;
		padding-right: 18px;
		font-size: 8px;
		font-weight: normal;
	} */

	.marker::before {
		content: "";
		display: inline-block;
		margin-right: 10px;
		border: 1px solid #01B0E0;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		font-size: 12px;
		font-weight: normal;
	}
	.card-warning {box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08)!important; border: 1px solid #ff8d72!important;}
	.card-danger {box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08)!important; border: 1px solid #f84e54!important;}
	.fioBlk a {font-size: 16px;}
	.badgeDeficient {background-color: rgb(124, 6, 8); color: white;}

	.ReLeadSearchCard >>> .btn-watch-icon i {font-size: 1.1rem; margin-top: 5px; display: block;}
	.ReLeadSearchCard >>> .objectDescr {width: 100%; }
	.ReLeadSearchCard >>> .objectDescr p {display: initial;}
	.expandBtn {
		background-color: transparent;
		border: none;
		outline: none;
		color: #9e77f3;
		padding-left: 0;
	}
	.expandBtn:hover {
		color: #01b0e0;
	}
	.collapseRegular {
		width: fit-content;
		max-width: 260px;
	}

	@media (max-width: 1350px){
		.card-user .right_part{display: block;}	
	}

	@media (max-width: 860px){
		.ReLeadSearchCard .card-user{
			display: block;
		}
		
		.uslugaBlk, .stageBlk, .taskBlk {margin-top: 20px;}
		.card-user .author {text-align: start; display: block;}
		.card-user .title h4 {margin-bottom: 5px;}
		.card-user .left_part {max-width: 100%; display: flex;}		
	}
	@media (max-width: 600px){
		.card-user .right_part > *{display: block; width: 100%;}
		.card-user .left_part {flex-direction: column;}		
	}
</style>
